import '../config';
import $, { event } from "jquery";

let lastController = null;

async function Api(TypeRequest, params, type_api = 'GET',cancelPrevious = false) {
    try {
      if (cancelPrevious && lastController) {
        lastController.abort();
      }
      const controller = new AbortController();

      if (cancelPrevious) {
        lastController = controller;
      }
      let url = `${global.config.domain_url}/rest/${TypeRequest}`;
      const options = {
        method: type_api,
        headers: {
          Accept: 'application/json',
        },
        credentials: 'include', // ارسال کوکی‌ها
        signal: controller.signal,
      };
      if (type_api === 'GET' && params) {
        const query = new URLSearchParams(params).toString();
        url += `?${query}`;
      }

      if (type_api !== 'GET' && params) {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(params);
      }

      const response = await fetch(url, options);

      if (!response.ok) {
        const err = await response.json().catch(() => response);
        throw err;
      }
      const data = await response.json();
      
      return data;
      
    } catch (error) {
         if (error.name === "AbortError") {
            // لغو درخواست، خطا را نادیده بگیرید
            return null;
          }
        throw error; // مدیریت خطا در جایی که این تابع استفاده می‌شود
    }
}
export default Api;
